
import { Component, Vue } from 'vue-property-decorator';

@Component<A3Page>({})
export default class A3Page extends Vue {}
